const INITIAL_STATE = {
  monthlyStats: [],
  orders: [],
};

const handCarryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_ALL_HANDCARRY_MONTHLY_STATS":
      return { ...state, monthlyStats: [...action.payload] };
    case "GET_ALL_HANDCARRY_ORDERS":
      return { ...state, orders: [...action.payload] };
    case "UPDATE_HANDCARRY_MONTHLY_STATS":
      const filteredStats = state.monthlyStats.filter(
        (stat) => stat.month !== action.payload.month
      );
      return { ...state, monthlyStats: [action.payload, ...filteredStats] };
    // Updates replace the order where it already sits rather than moving it
    // to the front — editing or settling a card must not make it jump to the
    // top of the list. A payload that isn't in the list yet is genuinely new
    // (createHandCarryOrderRedux dispatches this too), so that one is
    // prepended.
    case "UPDATE_HANDCARRY_ORDER":
      const alreadyListed = state.orders.some(
        (order) => order.id === action.payload.id
      );
      return {
        ...state,
        orders: alreadyListed
          ? state.orders.map((order) =>
              order.id === action.payload.id ? action.payload : order
            )
          : [action.payload, ...state.orders],
      };
    case "UPDATE_MULTIPLE_HANDCARRY_ORDERS":
      const settledById = action.payload.reduce((map, order) => {
        map[order.id] = order;
        return map;
      }, {});
      return {
        ...state,
        orders: state.orders.map((order) => settledById[order.id] || order),
      };
    case "DELETE_HANDCARRY_ORDER":
      const remainingOrders = state.orders.filter(
        (order) => order.id !== action.payload
      );
      return { ...state, orders: [...remainingOrders] };
    default:
      return state;
  }
};
export default handCarryReducer;
